// src/Home.js
import React from 'react';
import "./Home.css"; // Import the CSS file for styling

function Home() {
  <div class ="header-social">
           <h3>Why Everyone Choose Us?</h3>
        </div>
         
  
    return (
      
        <div className="home">
          <img src="/law.jpg" alt="Header" />
            <section className="statement-image-container">
                <div className="statement">
                    <h2>Why Everyone Choose Us?</h2>
                    <p>
                        We assure complete privacy of the facts of the case, not allowing 
                        other to look into or discuss the matter of one with others. 
                        Fantastic hi-tech legal service, giving you the utmost satisfaction 
                        you’ll need for your case materials to win the case. Sometime, 
                        we provide an open platform to some of our most vigilant clients to 
                        discuss with each other regarding their experiences and win win
                         moments. We’ll prepare our client to move on to the world.

                          We have a team of highly skilled and experienced lawyers who are
                          dedicated to providing top-notch legal services to our clients. Our
                          lawyers have a deep understanding of the law and are committed to
                          achieving the best possible outcomes for our clients. We have a proven
                          track record of success in handling a wide range of legal cases, and we
                          are confident in our ability to provide you with the legal representation
                          you need to achieve your goals.
                    </p>
                    <h4>Meet Our Founder</h4>
                    <h5>Dr. Anish Srivastava 'Lall' is the founder of Legal Experts India, 
                         a leading law firm based in Uttar Pradesh, India. With over 25 years 
                         of experience in the legal field, Dr. Lall has established himself as a 
                         prominent figure in the legal community. He is known for his expertise in 
                         various areas of law, including criminal law, civil law, and corporate law. 
                         Dr. Lall is committed to providing high-quality legal services to his 
                         clients and has successfully represented numerous individuals and businesses 
                         in complex legal matters. His dedication to justice and client satisfaction has 
                         earned him a reputation as one of the most trusted lawyers in the region.</h5>

                         <h4>Senior Panel Counsel, Government of India </h4>
                         <h4>Standing Counsel, NITI Ayog</h4>


                </div>

                      

                <div className="image-wrapper">
                    <img src="/khadya.jpeg" alt="Team" className="responsive-image" />
                </div>
            </section>


         
            <div className="intro-box">
                <h1>Our Moto</h1>
                <div className="motto">
                    <h3>Justice with Excellence, Integrity, and Dedication</h3>
                    <h3> -Dr. Anish Srivastava 'Lall'-</h3>
                </div>
            </div>

            

                 <section className="statement-image-container">
                  <img src="/practice.png" alt="Team" className="responsive-image" />
                <div className="statement">
                    <h1>Practice</h1>
                    <p>
                        At this legal group, we have a close knit and experienced team of 
                        legal assistants and support staff, who have their dedicated our 
                        career to achieving justice for the individuals and businesses who 
                        have been harmed by the conduct of others. Our firm was founded in 
                        2000 and ever since. We have worked hard to maintain the excellent 
                        reputation for integrity, commitment to our clients and results we 
                        have obtained for the people we represent, not only in Uttar Pradesh 
                        but throughout the India. Together, our advocates have over 40 year 
                        of experiences, resources, and knowledge, the advocate snaz staff at 
                        legal experts india are confident in our ability to provide you with 
                        the legal representation that will make a difference in the outcome of
                         your case.</p>
  
                </div>

                <div className="image-wrapper">
                    
                </div>
            </section>

<div className="links-container">
          <div className="links-box">
            <h3>Important Websites Related To Government of India</h3>
            <ul>
              <li>
                <a
                  href="http://supremecourtofindia.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  The Supreme Court, India
                </a>
              </li>
              <li>
                <a
                  href="http://india.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  National Portal of India
                </a>
              </li>
              <li>
                <a
                  href="http://eci.nic.in/eci/eci.html/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Election Commission of India
                </a>
              </li>
              <li>
                <a
                  href="http://mha.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ministry of Home Affairs
                </a>
              </li>
              <li>
                <a
                  href="http://www.mea.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ministry of External Affairs
                </a>
              </li>
              <li>
                <a
                  href="http://boi.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bureau Of Immigration
                </a>
              </li>
              <li>
                <a
                  href="http://nhrc.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  National Human Rights Commission
                </a>
              </li>
              <li>
                <a
                  href="http://passportindia.gov.in//"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Passport Services, India
                </a>
              </li>
              <li>
                <a
                  href="http://www.crpf.gov.in/default.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Central Reserve Police Force{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://bsf.gov.in/SitePages/Home.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Border Security Force
                </a>
              </li>
              <li>
                <a
                  href="http://www.ssb.nic.in/index.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sashastra Seema Bal
                </a>
              </li>
              <li>
                <a
                  href="http://itbpolice.nic.in/itbpwebsite/index.html/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Indo-Tibetan Border Police Force
                </a>
              </li>
            </ul>
          </div>

          <div className="links-box">
            <h3>Important Websites Related To Uttar Pradesh Govt.</h3>
            <ul>
              <li>
                <a
                  href="http://uplabour.gov.in/index.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Labour Departmentt, Government of Uttar Pradesh
                </a>
              </li>
              <li>
                <a
                  href="http://allahabadhighcourt.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Allahabad High Court
                </a>
              </li>
              <li>
                <a
                  href="http://ceouttarpradesh.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chief Electoral Officer, U.P.
                </a>
              </li>
              <li>
                <a
                  href="http://www.up.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Government Portal
                </a>
              </li>
              <li>
                <a
                  href="http://uppolice.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Police
                </a>
              </li>
              <li>
                <a
                  href="http://jansunwai.up.nic.in//"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Integrated Grievance Redressal System (IGRS), Government of
                  Uttar Pradesh{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://www.uppbpb.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Police Recruitment Board
                </a>
              </li>
              <li>
                <a
                  href="http://uptourism.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Tourism
                </a>
              </li>
              <li>
                <a
                  href="http://uplegisassembly.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Legislative Assembly
                </a>
              </li>
            </ul>
          </div>
        </div>

        </div>
    );
  
};

export default Home;